import React from 'react'
import { Link } from 'react-router-dom'
import ResourceDirectoryContent from '@/components/ResourceDirectoryContent'

const ResourceDirectoryPage: React.FC = () => (
  <main className="min-h-screen bg-gray-50 dark:bg-gray-950">
    <section className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <Link to="/" className="text-sm text-brand-600 hover:underline">← W.E.E. Guided Access</Link>
        <div className="mt-6 max-w-3xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-600">
            W.E.E. Humanitarian Resource & Navigation Network
          </p>
          <h1 className="mt-2 text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            Community Resource Directory
          </h1>
          <p className="mt-4 text-gray-600 dark:text-gray-300">
            Community resource information for the whole family and community — including food, housing, transportation, health, benefits, childcare, employment, family support, and other essential needs.
            W.E.E. does not guarantee eligibility, availability, acceptance, placement, or service capacity. The applicable provider or agency makes those decisions. If you need help choosing a pathway or connecting to a resource, start with Guided Access.
          </p>
        </div>
      </div>
    </section>

    <section className="max-w-6xl mx-auto px-4 py-8">
      <ResourceDirectoryContent />
    </section>
  </main>
)

export default ResourceDirectoryPage
